// Dependencies'
import React, {useState, useEffect, Fragment} from 'react'
import {connect} from 'react-redux'
import firebase from 'firebase/compat/app'
import 'firebase/compat/analytics'
// import {Route} from 'react-router-dom'
import Helpers from '../Helpers.js'
// import uiText from '../uiText.js'

// Actions
import {createFirebaseApp} from '../actions/createFirebaseApp'
import {storePayload} from '../actions/storePayload'
import {onSignInSuccess} from '../actions/onSignInSuccess.js'
import {summarize} from '../actions/summarize.js'

// Components
import {Notification, Icon} from '@lazarusai/forms-ui-components'
// import Example from './Example.js'
// import PromptWrapper from './PromptWrapper.js'
import OutputWrapper from './OutputWrapper.js'
import Authentication from './Authentication.js'
// import UserFeedback from './UserFeedback.js'

// Images
import Check from '../images/check.svg'
import Warning from '../images/warning.svg'

// Files
// import carCrash from '../demoFiles/carcrash.mp4'

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import styles from '../styles/App.module.css'

function App(props) {
  const [isNotificationVisible, setIsNotificationVisible] = useState(true)

  /* animates notification */
  const onClickNotification = () => {
    setIsNotificationVisible(false)
    setTimeout(() => {
      props.storePayload({
        userMessage: null,
        notificationType: null,
        notificationIcon: null,
      })
      setIsNotificationVisible(true)
    }, 300)
  }

  /* Show Welcome message on component mount */
  useEffect(() => {
    props.createFirebaseApp()
  }, [])

  /* Automatically close type 2 notifications */
  useEffect(() => {
    if (props.notificationType === 2) {
      setTimeout(onClickNotification, 5000)
    }
  }, [props.notificationType])

  function listenForAuthChange() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        props.onSignInSuccess(user, props.database)
      } else {
        /* User is not signed in */
        props.storePayload({
          isSignedIn: false,
          isFirebaseSignedIn: false,
          hasAttemptedSignIn: true,
          isLoading: false,
        })
      }
    })
  }

  useEffect(() => {
    if (Object.keys(props.firestore).length) {
      listenForAuthChange()
    }
  }, [props.firestore])

  return (
    <>
      {props.userMessage &&
        <Notification
          type={props.notificationType || 1}
          image={props.notificationIcon === 'check' ? Check : Warning}
          icon={
            <Icon
              icon={
                props.notificationIcon === 'check' ?
                  'checkmark' :
                  'alert-triangle-outline'
              }
              animation={null}
              fill={
                props.notificationIcon === 'check' ?
                  'var(--colors-brand-state-success)' :
                  'var(--colors-brand-state-warn-contrast-dark)'
              }
            />
          }
          content={props.userMessage}
          time={Helpers.timeStampToTime(Date.now())}
          isVisible={isNotificationVisible}
          onClick={onClickNotification}
          showBackdrop={props.notificationType === 3 ? true : false}
          theme='dark'
        />
      }
      <div className={styles.app}>
        {/* <Example /> */}
        {!props.isSignedIn ?
          <Authentication /> :
          <>
            {/* {!props.prompt ?
              <PromptWrapper /> :
              <OutputWrapper />
            } */}
            <OutputWrapper />
          </>
        }
        {/* <UserFeedback
          question={'What is the question???'}
          onAnswerSubmit={(answer) => console.log(answer)}
        /> */}
      </div>
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  prompt: state.userReducer.prompt,
})

export default connect(
    mapStateToProps,
    {createFirebaseApp, storePayload, onSignInSuccess, summarize},
)(App)

